// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NCeRvSRi4NvXJnTlSlX8{color:var(--content-primary-tertiary);font-size:14px;font-weight:500;line-height:20px;margin-top:16px}`, "",{"version":3,"sources":["webpack://./src/shared/ui/NoResultsFound/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,qCAAA,CACA,cAAA,CACA,eAAA,CACA,gBAAA,CACA,eAAA","sourcesContent":[".messageText {\n  color: var(--content-primary-tertiary);\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 20px;\n  margin-top: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"messageText": `NCeRvSRi4NvXJnTlSlX8`
};
export default ___CSS_LOADER_EXPORT___;
